import { render, staticRenderFns } from "./Initials.vue?vue&type=template&id=3bebc271&lang=pug&"
import script from "./Initials.vue?vue&type=script&lang=js&"
export * from "./Initials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports